import React from 'react';
import Header from '../header/Header';

function EmbedPage2() {
  return (
    <>
      <Header />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100vh' }}>
        <iframe
          src="https://qbsf.qa/ui/events/event-list-categories?event=61&publicView=true"
          width="100%"
          style={{ border: 'none', height: '100vh' }}
          allowFullScreen
          loading="lazy"
          title="QBSF Event"
        />
      </div>
    </>
  );
}

export default EmbedPage2;
